import { Detect } from "../internal/Detect"

/** `Image`, or `undefined` where the environment has none (absent in workers and node). */
export const GetImage = (): typeof Image | undefined => Detect("Image")
